import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-assigned-details',
  templateUrl: './assigned-details.component.html',
  styleUrls: ['./assigned-details.component.scss']
})
export class AssignedDetailsComponent implements OnInit {

  showDetails: boolean = false;
  panelOpenState = false;
  activeTab = 0;
  
 
  showDetailsEvent() {
    this.showDetails = !this.showDetails;       
    }
  ngOnInit(): void {
   

  }
  closeResult = '';

  constructor(private modalService: NgbModal) {}

  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }

 

}
